import React, { Component } from 'react';
import { connect } from 'react-redux';
import { combineStates, viewsState, viewSettingsState, viewsStateDispatcher, screenState } from '../store';
import { SvgImage } from './SvgImage';
import { ProductDeailedView, ProductSimpleView, listIcon2, listIcon3 } from '../../style/images';
import { PropTypes } from 'prop-types';
import { translate } from '../services';
import classNames from 'classnames';
import { ScreenType } from '../model';
import { Box, IconButton } from '@mui/material';

const ViewIcon = ( { active, changeView, viewType } ) => {
  const onChange = () => changeView( viewType.view );

  let svgClassName= active? classNames("svg-tooltip", "active"): "svg-tooltip"
  
  // return <SvgImage 
  //   source={ viewType.view === 'simple' ? ProductSimpleView : ProductDeailedView } 
  //   toolTip={ translate( viewType.view === 'simple' ? 'List view' : 'Detailed view' ) } 
  //   className={ 'view-icons'} 
  //   onClick={ onChange }
  //   svgClassName={active? classNames("svg-tooltip", "active"): "svg-tooltip"}
  // />;
  let className = 'view-icons'
  let svg =<div className='view-icons'>
    <IconButton disableFocusRipple disableRipple disableTouchRipple sx={{height:"16px",padding:"0px", "&.MuiButtonBase-root:hover": {
                bgcolor: "transparent"
              }}} onClick={onChange}><Box component="img" src={viewType.view === 'simple' ? ProductSimpleView : ProductDeailedView}></Box></IconButton>
  </div>
  let toolTip= translate( viewType.view === 'simple' ? 'List view' : 'Detailed view' ) 
  return toolTip ? <div className={svgClassName} title={ toolTip } >{ svg }</div> : svg;
};

export class ViewSelectorComponent extends Component {
  changeView = viewType => this.props.changeView( this.props.view, viewType )

  render() {
    const { screen, view, views, viewSettings } = this.props;
    const activeView = views[view];
    const screenType = ScreenType.getScreenType( screen, viewSettings[view] );
    const selectableViewTypes = Object.values( viewSettings[view][screenType] ).filter( layout => layout && layout.isSelectable );

    if( selectableViewTypes.length < 2 ) {
      return null;
    }

    const viewIcons = selectableViewTypes.map( viewType => <ViewIcon
      key={ viewType.view }
      active={ viewType.view === activeView }
      changeView={ this.changeView }
      viewType={ viewType }
    /> );

    return <div className="view-selector">
      { viewIcons }
    </div>; 
  }
}

ViewSelectorComponent.propTypes = {
  changeView: PropTypes.func.isRequired,
  screen: PropTypes.shape( {
    isMobile: PropTypes.bool.isRequired,
    isTablet: PropTypes.bool.isRequired
  } ),
  view: PropTypes.string.isRequired,
  viewSettings: PropTypes.shape( {} ).isRequired
};

export const ViewSelector = connect( combineStates( screenState, viewsState, viewSettingsState ), viewsStateDispatcher )( ViewSelectorComponent );